import { WIZARD_STEP_NAME, WIZARD_STEP_PATH } from "../router/path/wizard";

export const colorByStatus = (status) => {
  if (status === "active") {
    return "#1677ff";
  }

  if (status === "success") {
    return "#52c41a";
  }

  return "#0091c9";
};

export const SELECT_WITH_FIELDS = {
  Orders: ["Customers"],
  Customers: ["Orders"],
};

export const SELECT_WITH_EXCEPTIONS = {
  FILTER: ["Orders"],
  PUSH: ["Customers"],
};

export const updateEntitiesSelectWith = (itemKey) =>
  SELECT_WITH_FIELDS[itemKey] || "";

export const isEntityPluginDisabled = (pluginData) =>
  Boolean(
    pluginData &&
      typeof pluginData === "object" &&
      !pluginData.pluginInstalled,
  );

export const updateEntitiesChildren = (
  children,
  plugin,
  details,
  parentDisabled = false,
) => {
  const updatedChildren = children?.map((child) => {
    const pluginEntry = plugin?.[child?.key];
    const pluginData = pluginEntry && {
      cartId: pluginEntry?.cartId,
      notice: pluginEntry?.notice,
      pluginInstalled: pluginEntry?.pluginInstalled,
      entityKey: pluginEntry?.entityKey,
      storeType: pluginEntry?.storeType,
      title: pluginEntry?.title,
      type: pluginEntry?.type,
    };
    const disabled =
      isEntityPluginDisabled(pluginEntry) || parentDisabled;

    const updatedChild = {
      ...child,
      additional_options: pluginData,
      disabled,
      fields_select_with: updateEntitiesSelectWith(child.key),
      connect: child?.connect,
      count: details?.[child.key]?.count || 0,
    };

    if (child?.children?.length) {
      updatedChild.children = updateEntitiesChildren(
        child.children,
        plugin,
        details,
        disabled,
      );
    }

    return updatedChild;
  });

  return updatedChildren;
};

export const updateEntities = (entities, plugin, details) => {
  const data = entities?.map((item) => {
    const parentDisabled = isEntityPluginDisabled(plugin?.[item?.key]);

    return {
      key: item?.key,
      name: item?.name,
      limit: "20 within demo",
      children: updateEntitiesChildren(
        item?.children,
        plugin,
        details,
        parentDisabled,
      ),
      fields_select_with: updateEntitiesSelectWith(item?.key),
      additional_options: plugin?.[item?.key],
      disabled: parentDisabled,
      count: details?.[item?.key]?.count || 0,
    };
  });

  return data;
};

export const updateFiles = (resources) => {
  if (resources?.db) {
    return [];
  }

  return Object.entries(resources || {}).map(([id, item], index) => ({
    id,
    key: index + 1,
    name: item.title,
    uploadedFiles: item.uploadedFiles,
    type: item.type,
    status: item.uploaded,
    required: item.required,
    comment: item.comment,
  }));
};

export const entityQuery = (entities) => {
  const data = entities?.map((item, index) => {
    if (index === 0) {
      return `&entities[]=${item}&`;
    }

    return `entities[]=${item}&`;
  });

  return data?.join("");
};

export const removeValueFromObject = (key, obj) => {
  if (obj?.[key]) {
    const { [key]: deletedValue, ...rest } = obj;
    const { sets: deletedSets, ...newRest } = rest;

    return {
      ...newRest,
      ...rest?.sets?.groups?.api,
      // ...rest?.sets?.groups?.admin,
    };
  }

  if (obj?.sets) {
    const { sets: deletedSets, ...newRest } = obj;

    return {
      ...newRest,
      // ...obj?.sets?.groups?.api,
    };
  }

  return {
    ...obj,
  };
};

export const entitiesToTableData = (entities, count) => {
  if (!entities) return [];

  return Object.entries(entities).map(([entityKey, entity]) => ({
    key: entityKey,
    title: entityKey,
    count: count?.[entityKey] ?? "-",
    children: entity.fields.map((field) => ({
      key: `${entityKey}.${field}`,
      title: entity.fieldNames?.[field] || field,
    })),
  }));
};

export const getEntitiesAllKeys = (entities) => {
  if (!entities) return [];
  let keys = [];
  Object.entries(entities).forEach(([entityKey, entity]) => {
    keys.push(entityKey);
    if (entity.fields) {
      keys = keys.concat(entity.fields.map((field) => `${entityKey}.${field}`));
    }
  });
  return keys;
};

export const keysToEntitiesObject = (keys, allEntities) => {
  const result = {};
  keys.forEach((key) => {
    const [entityKey, field] = key.split(".");
    if (!result[entityKey]) {
      result[entityKey] = { fields: [] };
    }
    if (field) {
      if (
        allEntities[entityKey] &&
        allEntities[entityKey].fields.includes(field) &&
        !result[entityKey].fields.includes(field)
      ) {
        result[entityKey].fields.push(field);
      }
    }
  });
  return result;
};

export const WIZARD_TIMEOUT_MS = 300000;

export const getStepTitle = (screen) => {
  const stepKey = Object.keys(WIZARD_STEP_PATH).find(
    (key) => WIZARD_STEP_PATH[key] === screen,
  );

  return stepKey ? WIZARD_STEP_NAME[stepKey] : "";
};

export const unknownCart = {
  value: "UnknownCart",
  label: "Select your Source Platform",
};
